/* eslint-disable import/no-unresolved */
import React from "react";
import classNames from "classnames";
import { bool, func } from "prop-types";

import Button from "pages/_components/Button";
import PagesDownloadButton from "pages/_components/DownloadButton";

/**
 * Mobile-only control for the v3 private shell header: single-format (PDF) download action.
 * Mirrors the `uniqueDownload` block on the legacy `Head` toolbar on small viewports.
 */
export function DownloadButton({ handleClick, isFetchingExport, downloadImageWhite, exportDisabled }) {
    return (
        <div className={classNames("toolbar-item", "mt-0", "toolbar-item-right")} key="v3-shell-export-unique">
            <Button
                onClick={() => handleClick("pdf")}
                label={false}
                className={classNames("btn btn-outline download", "button-white-header mx-0")}
                image={`images/download_bold${downloadImageWhite ? "_white" : ""}.svg`}
                imageStyle="toolbar-btn-image-mobile svg25"
                loading={false}
                disabled={isFetchingExport || exportDisabled}
            />
        </div>
    );
}

DownloadButton.propTypes = {
    handleClick: func.isRequired,
    isFetchingExport: bool,
    downloadImageWhite: bool,
    exportDisabled: bool,
};

DownloadButton.defaultProps = {
    isFetchingExport: false,
    downloadImageWhite: false,
    exportDisabled: false,
};

/**
 * Mobile-only export menu (CSV/XLS/PDF, etc.) for the v3 shell header.
 * Same role as the `DownloadButton` inside legacy `Head` when `exportList` is set without `uniqueDownload`.
 */
export function ExportDownloadButton(props) {
    return <PagesDownloadButton isMobile {...props} />;
}
